import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=71086b6e&scoped=true&"
import script from "./loginLayout.vue?vue&type=script&lang=js&"
export * from "./loginLayout.vue?vue&type=script&lang=js&"
import style0 from "./loginLayout.vue?vue&type=style&index=0&id=71086b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71086b6e",
  null
  
)

export default component.exports